(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loubna-pack-landing"] && !Shopify.designMode) return;
  try {
    
function lpBuildCodUrl(landing, quantity) {
  var raw = landing.dataset.codUrl || '/pages/commande-pack-my-first-steps#cod-checkout';
  var target = new URL(raw, window.location.origin);
  var current = new URL(window.location.href);
  var previewThemeId = current.searchParams.get('preview_theme_id');

  if (previewThemeId) {
    target.searchParams.set('preview_theme_id', previewThemeId);
  }

  target.searchParams.set('pack_qty', String(Math.max(1, Number(quantity || 1))));
  target.hash = 'cod-checkout';
  return target.toString();
}

function lpDirectOrder(button) {
  var landing = button.closest('.lp-compact');
  if (!landing || button.disabled) return;

  var quantityInput = landing.querySelector('.lp-qty input[name="quantity"]');
  var quantity = quantityInput ? Math.max(1, Number(quantityInput.value || 1)) : 1;

  button.disabled = true;
  button.textContent = 'جاري فتح الاستمارة...';
  window.location.assign(lpBuildCodUrl(landing, quantity));
}

document.addEventListener('click', function (event) {
  var directOrder = event.target.closest('[data-direct-order]');
  if (directOrder) {
    event.preventDefault();
    lpDirectOrder(directOrder);
    return;
  }

  var button = event.target.closest('[data-qty-action]');
  if (!button) return;

  var control = button.closest('.lp-qty');
  if (!control) return;

  var input = control.querySelector('input[type="number"]');
  if (!input) return;

  var current = parseInt(input.value || '1', 10);
  var min = parseInt(input.min || '1', 10);

  input.value = button.dataset.qtyAction === 'plus'
    ? current + 1
    : Math.max(min, current - 1);

  input.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('submit', function (event) {
  var form = event.target.closest('.lp-order-form');
  if (!form) return;

  event.preventDefault();
  var button = form.querySelector('[data-direct-order]');
  if (button) lpDirectOrder(button);
});

  } catch(e) { console.error(e); }
})();
})();
